import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from 'features/auth';
import { ROUTES } from 'lib/constants';

/** Guards authenticated areas; redirects to /login when signed out. */
export function ProtectedRoute() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace state={{ from: location }} />;
  }
  return <Outlet />;
}

export default ProtectedRoute;
